module.exports = __webpack_public_path__ + "img/button-default.e9a4117e.png";